// components/BrandsCarousel.js
import React, { useEffect, useRef } from 'react';

const BrandsCarousel = () => {
  const brands = [
    { name: 'Jinko Solar', image: '/images/brands/jinko-solar.png' },
    { name: 'Canadian Solar', image: '/images/brands/canadian-solar.png' },
    { name: 'Trina Solar', image: '/images/brands/trina-solar.png' },
    { name: 'Schneider Electric', image: '/images/brands/schneider-electric.png' },
    { name: 'Siemens', image: '/images/brands/siemens.png' },
    { name: 'ABB', image: '/images/brands/abb.png' },
    { name: 'Himel', image: '/images/brands/himel.png' },
    { name: 'CNC', image: '/images/brands/cnc.png' },
    { name: 'Danfoss', image: '/images/brands/danfoss.png' }
  ];

  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    let scrollPosition = 0;
    const speed = 0.6;

    const scroll = () => {
      scrollPosition += speed;
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      scrollContainer.scrollLeft = scrollPosition;
      animationId = requestAnimationFrame(scroll);
    };

    const startScroll = () => {
      animationId = requestAnimationFrame(scroll);
    };

    const stopScroll = () => {
      if (animationId) {
        cancelAnimationFrame(animationId);
      }
    };

    startScroll();

    scrollContainer.addEventListener('mouseenter', stopScroll);
    scrollContainer.addEventListener('mouseleave', startScroll);

    return () => {
      stopScroll();
      scrollContainer.removeEventListener('mouseenter', stopScroll);
      scrollContainer.removeEventListener('mouseleave', startScroll);
    };
  }, []);

  const duplicatedBrands = [...brands, ...brands];

  return (
    <div className="bg-white py-12 border-y border-gray-100">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-8">
          <span className="text-[#006D77] font-semibold text-sm uppercase tracking-wider inline-block bg-[#006D77]/10 px-4 py-1.5 rounded-full">
            Trusted Partners
          </span>
          <h3 className="text-xl font-bold text-gray-900 mt-3">
            Working with Industry Leaders
          </h3>
        </div>
        
        <div 
          ref={scrollRef}
          className="overflow-x-hidden scroll-smooth"
        >
          <div className="flex gap-12 items-center" style={{ width: 'max-content' }}>
            {duplicatedBrands.map((brand, index) => (
              <div 
                key={index} 
                className="flex-shrink-0 flex flex-col items-center gap-2 group"
              >
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden bg-gray-50 border-2 border-gray-100 group-hover:border-[#006D77] transition-all duration-300 flex items-center justify-center p-2">
                  <img 
                    src={brand.image} 
                    alt={brand.name}
                    className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                    onError={(e) => {
                      e.target.src = `https://ui-avatars.com/api/?name=${brand.name.replace(/ /g, '+')}&background=006D77&color=fff&size=80&rounded=true`;
                    }}
                  />
                </div>
                <span className="text-[10px] md:text-xs text-gray-500 font-medium text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  {brand.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandsCarousel;
